
// import ids from '@iris-platform/ids-js-sdk';
import { replace, is } from 'ramda';
import elasticsearch from 'elasticsearch';
import { resolver } from '../util';
import config from '../../config';
import Queries from './queries';

const esSearch = query => new Promise((resolve, reject) => {
  const searchProps = { ...config.elasticSummaryProps };
  // console.log(searchProps);
  if (!is(Number, config.elasticSummaryProps.requestTimeout)) {
    searchProps.requestTimeout = parseInt(config.elasticSummaryProps.requestTimeout, 10);
  }
  // console.log(`searchProps: ${JSON.stringify(searchProps, null, 2)}`);
  const client = new elasticsearch.Client(searchProps);
  // console.log('send query to ES');
  client.search(query.query, (error, response) => {
    let results = null;
    if (error) {
      const msg = 'There was an error getting data from Elastic Search';
      console.error(error.message);
      console.log(msg);
      reject(error);
    }
    if (response && !response.aggregations) {
      console.log('response.aggregations missing for query');
      console.log(response);
      resolve(response);
    }
    if (response && response.aggregations && response.aggregations.ByDomain
      && response.aggregations.ByDomain.buckets.length > 0) {
      results = response.aggregations.ByDomain.buckets;
      // console.log(`results: ${JSON.stringify(results, null, 2)}`);
      resolve(results);
    }
  });
});

const getCallAttempts = resolver.authenticatedResolver.createResolver(
  async (root, { startTime, endTime, appDomain }) => {
    const appDomainSelected = appDomain;
    // if (appDomainSelected) {
    //   console.log('replace selected appdomain in query');
    // }
    const query = JSON.parse(JSON.stringify(Queries.CallAttemptsQuery));
    // console.log('getCallAttempts query');
    query.query.body.query.bool.must[1].range.utc_date.gte = startTime;
    query.query.body.query.bool.must[1].range.utc_date.lte = endTime;
    let queryString = query.query.body.query.bool.must[0].query_string.query;
    queryString = replace(/###AppDomainPlaceholder###/, appDomainSelected, queryString);
    query.query.body.query.bool.must[0].query_string.query = queryString;
    let searchResult = {};
    try {
      searchResult = await esSearch(query);
    } catch (err) {
      console.error('ES Search Returned error: ', err);
    }
    // console.log(searchResult);
    return searchResult;
  },
);

const getOutboundCalls = resolver.authenticatedResolver.createResolver(
  async (root, { startTime, endTime, appDomain }) => {
    const appDomainSelected = appDomain;
    // if (appDomainSelected) {
    //   console.log('replace selected appdomain in query');
    // }
    const query = JSON.parse(JSON.stringify(Queries.OutboundCallQuery));
    // console.log('getOutboundCalls query');
    query.query.body.query.bool.must[1].range.utc_date.gte = startTime;
    query.query.body.query.bool.must[1].range.utc_date.lte = endTime;
    let queryString = query.query.body.query.bool.must[0].query_string.query;
    queryString = replace(/###AppDomainPlaceholder###/, appDomainSelected, queryString);
    query.query.body.query.bool.must[0].query_string.query = queryString;
    let searchResult = {};
    try {
      searchResult = await esSearch(query);
    } catch (err) {
      console.error('ES Search Returned error: ', err);
    }
    // console.log(searchResult);
    return searchResult;
  },
);

const getInboundCalls = resolver.authenticatedResolver.createResolver(
  async (root, { startTime, endTime, appDomain }) => {
    const appDomainSelected = appDomain;
    // if (appDomainSelected) {
    //   console.log('replace selected appdomain in query');
    // }
    const query = JSON.parse(JSON.stringify(Queries.InboundCallQuery));
    // console.log('getInboundCalls query');
    query.query.body.query.bool.must[1].range.utc_date.gte = startTime;
    query.query.body.query.bool.must[1].range.utc_date.lte = endTime;
    let queryString = query.query.body.query.bool.must[0].query_string.query;
    queryString = replace(/###AppDomainPlaceholder###/, appDomainSelected, queryString);
    query.query.body.query.bool.must[0].query_string.query = queryString;
    let searchResult = {};
    try {
      searchResult = await esSearch(query);
    } catch (err) {
      console.error('ES Search Returned error: ', err);
    }
    // console.log(searchResult);
    return searchResult;
  },
);

const getOnNetCalls = resolver.authenticatedResolver.createResolver(
  async (root, { startTime, endTime, appDomain }) => {
    const appDomainSelected = appDomain;
    // if (appDomainSelected) {
    //   console.log('replace selected appdomain in query');
    // }
    const query = JSON.parse(JSON.stringify(Queries.OnNetCallQuery));
    // console.log('getOnNetCalls query');
    query.query.body.query.bool.must[1].range.utc_date.gte = startTime;
    query.query.body.query.bool.must[1].range.utc_date.lte = endTime;
    let queryString = query.query.body.query.bool.must[0].query_string.query;
    queryString = replace(/###AppDomainPlaceholder###/, appDomainSelected, queryString);
    query.query.body.query.bool.must[0].query_string.query = queryString;
    let searchResult = {};
    try {
      searchResult = await esSearch(query);
    } catch (err) {
      console.error('ES Search Returned error: ', err);
    }
    // console.log(searchResult);
    return searchResult;
  },
);

const getHighRiskCalls = resolver.authenticatedResolver.createResolver(
  async (root, { startTime, endTime, appDomain }) => {
    const appDomainSelected = appDomain;
    // if (appDomainSelected) {
    //   console.log('replace selected appdomain in query');
    // }
    const query = JSON.parse(JSON.stringify(Queries.HighRiskQuery));
    console.log('getHighRiskCalls query');
    query.query.body.query.bool.must[1].range['@timestamp'].gte = startTime;
    query.query.body.query.bool.must[1].range['@timestamp'].lte = endTime;
    let queryString = query.query.body.query.bool.must[0].query_string.query;
    queryString = replace(/###AppDomainPlaceholder###/, appDomainSelected, queryString);
    query.query.body.query.bool.must[0].query_string.query = queryString;
    let searchResult = {};
    try {
      searchResult = await esSearch(query);
    } catch (err) {
      console.error('ES Search Returned error: ', err);
    }
    // console.log(searchResult);
    return searchResult;
  },
);

export default {
  Query: {
    getCallAttempts,
    getOutboundCalls,
    getInboundCalls,
    getOnNetCalls,
    getHighRiskCalls,
  },
};
